"use client";
import { EnvironmentOutlined, UnorderedListOutlined } from "@ant-design/icons";
import React from "react";
import { useBrowse } from "../../lib/hooks";

const ViewSwitch = () => {
  const { isMapView, changeMapView } = useBrowse();
  return (
    <div
      className="location-view-options"
      role="group"
      aria-label="Browse locations"
    >
      <button
        type="button"
        aria-pressed={!isMapView}
        onClick={() => changeMapView(false)}
      >
        <UnorderedListOutlined aria-hidden="true" /> List
      </button>
      <button
        type="button"
        aria-pressed={isMapView}
        onClick={() => changeMapView(true)}
      >
        <EnvironmentOutlined aria-hidden="true" /> Map
      </button>
    </div>
  );
};

export default ViewSwitch;
